import { selectAuth } from "@redux";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { ComponentFitnessCampaign } from "../../Components/FitnessCampaign/Main";

export const PageFitnessCampaign = () => {
    const { userInfo } = useSelector(selectAuth);

    const memberTier = userInfo?.memberTier;


    return <ComponentFitnessCampaign memberTier={memberTier} avatar={""} fullName={""} socials={[]} />;
};
